import { fetcher } from '@/shared/api/fetcher';
import { usePathname } from 'next/navigation';
import useSWR from 'swr';

export type PageMetadata = {
  title?: string;
  h1?: string;
  pageText?: string;
  [key: string]: unknown;
};

export  const usePageMetadata = (fallbackData?: PageMetadata | null) => {
  const pathname = usePathname();
  const url = `/metadata?page=${pathname}`;
  const { data, isLoading, error } = useSWR<PageMetadata>(
    url,
    (url) => fetcher(url),
    {
      fallbackData: fallbackData ?? undefined,
    }
  );

  return { data, isLoading, error };
}
